import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';

import {GetRegion2Css, GetRegion2Name} from '../../defines/client.const';
import {makeYoutubeUrl} from '../../defines/client.func';
import {Video} from '../../models/video.model';
import {YoutubeService} from '../../services/youtube/youtube.service';
import {VideoHistoryService} from '../../services/video/video-history.service';


@Component({
  selector: 'app-video-box',
  templateUrl: './video-box.component.html',
})
export class VideoBoxComponent {
  @Input() video: Video;
  // tslint:disable-next-line:variable-name
  private _sendingBookmark: boolean;
  @Input() set sendingBookmark(value: boolean) {
    this._sendingBookmark = value;
  }
  @Output() toggleBookmark: EventEmitter<Video>;
  @Output() playVideo: EventEmitter<Video>;

  protected readonly GetRegion2Css = GetRegion2Css;
  protected readonly GetRegion2Name = GetRegion2Name;

  constructor(
    protected sanitizer: DomSanitizer,
    protected youtube: YoutubeService,
    protected historySvc: VideoHistoryService,
  ) {
    this.toggleBookmark = new EventEmitter<Video>();
    this.playVideo = new EventEmitter<Video>();
  }

  public ToggleBookmark(event: MouseEvent, video: Video): void {
    event.preventDefault();
    event.stopPropagation();
    if (this._sendingBookmark) {
      return;
    }
    this.toggleBookmark.emit(this.video);
  }

  public OpenYoutube(video: Video): void {
    this.historySvc.addHistory(video.no);

    this.youtube.Open(video.youtubeId).subscribe(
      () => {},
      error => {
        // TODO: 좀더 우아한 방법을 고려 필요함.
        console.log('Cordova 가 없다. 윈도우창을 여러서 유튜브 호출');
        // window.open(`https://www.youtube.com/embed/${video.youtubeId}?autoplay=1&mute=0&rel=0`, '_blank');
      }
    );
    this.playVideo.emit(this.video);
  }

  public getBmCss(video: Video): string {
    if (this.sendingBookmark) {
      return 'ing';
    }
    return video.bookmark ? 'on' : '';
  }

  public makeYoutubeUrl(youtubeId: string): SafeStyle {
    const url = makeYoutubeUrl(youtubeId);
    return this.sanitizer.bypassSecurityTrustStyle(`url(${url}) no-repeat center / cover`);
  }
}
